// src/pages/FAQ.jsx
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const faqs = [
  {
    question: 'Do I have to pay to apply for jobs?',
    answer: 'No. You should never pay to apply for any job. All listings on our platform are free to view and apply to.'
  },
  {
    question: 'Do I need an account to view jobs?',
    answer: 'No registration is required. You can freely browse and apply to jobs without creating an account.'
  },
  {
    question: 'How often is job data updated?',
    answer: 'We update our listings in real-time. Expired or filled jobs are removed automatically.'
  },
  {
    question: 'What should I do if I suspect a scam listing?',
    answer: 'Please report it immediately to info@currentjobs.co.ke. We investigate all reports and remove harmful listings promptly.'
  },
  {
    question: 'Is my data safe?',
    answer: 'Yes. We do not collect personal information unless you voluntarily contact us. No cookies, tracking pixels, or analytics tools are used without consent.'
  }
];

const FAQ = () => (
  <>
    <Header />
    <main style={styles.main}>
      <h1>Frequently Asked Questions (FAQ)</h1>
      <p>Below are answers to common questions from job seekers:</p>
      <div style={styles.faqList}>
        {faqs.map((faq, index) => (
          <div key={index} style={styles.faqItem}>
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </main>
    <Footer />
  </>
);

const styles = {
  main: {
    padding: '2rem',
    maxWidth: '800px',
    margin: 'auto',
    lineHeight: 1.6
  },
  faqList: {
    marginTop: '2rem'
  },
  faqItem: {
    marginBottom: '1.5rem',
    background: '#f7f7f7',
    padding: '1rem',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.05)'
  }
};

export default FAQ;
